/**
 * moduleAccess.js
 * Single Source of Truth for module normalization, aliasing, and entitlement verification.
 * Avoids duplicated ad-hoc module checking logic across useAuth, DashboardLayout, and navigation.
 */

export const MODULE_ALIASES = {
  telephony: 'loop',
  loop: 'loop',
}

/**
 * Normalizes a module code string, mapping legacy aliases to canonical module keys.
 * E.g., 'telephony' -> 'loop'.
 */
export function normalizeModuleCode(code) {
  if (!code) return ''
  const lower = String(code).trim().toLowerCase()
  return MODULE_ALIASES[lower] || lower
}

/**
 * Checks whether the user's active session modules satisfy the requiredModule condition.
 * Handles normalization, aliasing (e.g. telephony <-> loop), and case-insensitivity.
 *
 * @param {string} requiredModule - The module code required by the screen or menu item.
 * @param {Array<string>} sessionModules - The active modules from the user's JWT / session.
 * @returns {boolean} - True if access is authorized, false otherwise.
 */
export function checkModuleEntitlement(requiredModule, sessionModules = []) {
  if (!requiredModule) return true
  const target = normalizeModuleCode(requiredModule)
  const activeList = Array.isArray(sessionModules) ? sessionModules : []
  return activeList.some((m) => normalizeModuleCode(m) === target)
}
